import { PanelGroup } from '@hai/ui-react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useWatchObject } from 'src/js/store/use-watch';
import { StreamViewModel } from 'src/js/pages/streaming/stream/stream-models';
import { isNilOrEmpty } from 'src/js/util/global-util';

import { DashboardStreamPanel } from './dashboard-stream-panel';
import streams, { resetStreamStatistics } from 'src/js/pages/streaming/stream/stream-store';
import { createAndDispatchNotification } from 'src/js/notification/notification-helper';
import { NotificationVariant } from 'src/js/notification/notification';
import { streamListStreamName } from '../streaming/stream/stream-view-model-mapper';

interface Props {
  triggerRefresh: () => void;
}

export const DashboardStreamList: React.FunctionComponent<Props> = (props) => {
  const { t } = useTranslation();

  const [viewModels, setViewModels] = useState(streams);
  useWatchObject(streams, setViewModels);

  const handleResetStatistics = (model: StreamViewModel) => {
    resetStreamStatistics(model, t).then((res) => {
      props.triggerRefresh?.();
      if (res.ok) {
        createAndDispatchNotification(
          isNilOrEmpty(model.name)
            ? t('stream.notifications.clearStatsSuccessEmptyName')
            : t('stream.notifications.clearStatsSuccess', {
                name: streamListStreamName(t, model.name),
              }),
          NotificationVariant.SUCCESS,
          t,
        );
      }
    });
  };

  const sortByState = (a: StreamViewModel, b: StreamViewModel) => {
    const nameA = a.stateSortable;
    const nameB = b.stateSortable;
    return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
  };
  const sortByName = (a: StreamViewModel, b: StreamViewModel) => {
    const nameA = a.name.toUpperCase();
    const nameB = b.name.toUpperCase();
    return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
  };

  if (isNilOrEmpty(viewModels)) {
    return null;
  }

  // Only display created streams
  const filtered = viewModels.filter((s: StreamViewModel) => s.id !== -1);

  return (
    <div id="streams">
      {/* TODO: show only favorites and/or max X amount */}
      <PanelGroup className="grid-4x">
        {filtered
          .sort(sortByName)
          .sort(sortByState)
          .map((value: StreamViewModel, _index: number) => (
            <DashboardStreamPanel key={`${value.id}`} model={value} onClearStats={handleResetStatistics} />
          ))}
      </PanelGroup>
    </div>
  );
};
